import { render, staticRenderFns } from "./UtilityBarButton.vue?vue&type=template&id=ae85f0a4&"
import script from "./UtilityBarButton.vue?vue&type=script&lang=ts&"
export * from "./UtilityBarButton.vue?vue&type=script&lang=ts&"
import style0 from "./UtilityBarButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports